import toastr from 'toastr'

const config: ToastrOptions = {
    positionClass: 'toast-bottom-left',
}

export function success(msg: string, title?: string) {
    return toastr.success(msg, title, config)
}

export function error(msg: string, title?: string) {
    return toastr.error(msg, title, config)
}

export const errors = {
    sendFile() {
        error(
            'Video file must match following requirements: min. frame rate - 24 , maximum duration - 3 minutes, min resolution - 200x200px, max. size - 100mb. Image file must match following requirements: min resolution - 200x200px, max. size - 100mb.'
        )
    },
    fileIsBig() {
        error('File size exceeds allowed size. Max size is 15 mb.')
    },
    pickTheFile() {
        error('Pick the file.')
    },
    fillRequireFields() {
        error('Fill in the required fields.')
    },
    bidIsLessThanMin() {
        error('Your bid is less than minimum required amount.')
    },
    actionCanceled() {
        error('Action canceled')
    },
    fieldsHaveErrors() {
        error('Fields have errors')
    },
    invalidFileExtension() {
        error('Invalid file extension')
    },
    changeToBsc() {
        error('You have to change your network to BSC')
    },
    needMetamask() {
        error(`You don't have a metamask!`)
    },
    emailIsUsed() {
        error('This E-mail is used')
    },
    metaNameIsUsed() {
        error('This username is used')
    },
    fullscreen() {
        error("Fullscreen doesn't have a permission in your browser")
    },
    fillExpire() {
        error('Enter the full date')
    },
    minExpire() {
        error('The minimum value is 24 hours')
    },
    smallBalance() {
        error('Insufficient balance')
    },
}

export const notifications = {
    NFTSendToModeration() {
        success('Your NFT successfully sent to moderation')
    },
    copied() {
        success('Copied!')
    },
    authMessageSended() {
        success('The message sended to your device')
    },
    bought() {
        success('Bought!')
    },
}
